import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";
import { GET_TENANT_HOSPITAL_LIST_QUERY_KEY } from "../types/CommonTypes";
import { TENANTS_HOSPITALS_LIST_RESPONSE } from "../types/ResponseTypes";

async function getTenantsHospitalsList(): Promise<TENANTS_HOSPITALS_LIST_RESPONSE> {
  const { userId, realm } = getAuthValue();
  const { data } = await fetcher({
    url: "admin/tenants/hospitals",
    headers: {
      "x-realm": realm ?? "",
      "x-user-id": userId ?? "",
    },
  });
  return data;
}

function useGetTenanatsHospitalsListQuery() {
  return useQuery({
    queryKey: [GET_TENANT_HOSPITAL_LIST_QUERY_KEY],
    queryFn: () => getTenantsHospitalsList(),
  });
}

export default useGetTenanatsHospitalsListQuery;
